export default [
  /* AXT */
  {
    id: "CRE",
    color: 'yellowLight',
    summary: 'Recibido en nuestra plataforma',
    icon: 'mdi-monitor'
  },
  {
    id: "MRT",
    color: 'yellowLight',
    summary: 'Documento reprocesado manualmente',
    icon: 'mdi-gesture-double-tap'
  },
  {
    id: "ART",
    color: 'yellowLight',
    summary: 'Procesando',
    icon: 'mdi-sync'
  },
  {
    id: "APR",
    color: 'lightBlue',
    summary: 'Documento aprobado por la agencia',
    icon: 'mdi-file-check'
  },
  {
    id: "OBS",
    color: 'purpleLight',
    summary: 'Documento aprobado con observaciones por la agencia',
    icon: 'mdi-file-eye'
  },
  {
    id: "SNT",
    color: 'blueGreyLighten',
    summary: 'Enviado a la agencia',
    icon: 'mdi-bank'
  },
  {
    id: "FAI",
    color: 'blueGreyLighten',
    summary: 'Pendiente',
    icon: 'mdi-clock'
  },
  {
    id: "REJ",
    color: 'redLight',
    summary: 'Rechazado por la agencia',
    icon: 'mdi-bank-remove'
  },
  {
    id: "DUP",
    color: 'redLight',
    summary: 'Documento rechazado por duplicidad en la agencia',
    icon: 'mdi-file-remove-outline'
  },
  {
    id: "VOI",
    color: 'greyMedium',
    summary: 'Anulado',
    icon: 'mdi-file-cancel-outline'
  },
  {
    id: "EST",
    color: 'blueGreyLighten',
    summary: 'Enviado por mail',
    icon: 'mdi-email-arrow-right'
  },
  {
    id: "INV",
    color: 'blueGreyLighten',
    summary: 'Documento invalidado',
    icon: 'mdi-file-remove-outline'
  },
  {
    id: "PRE",
    color: 'blueGreyLighten',
    summary: 'Documento por confirmar',
    icon: 'mdi-file-outline'
  },
  {
    id: "CSM",
    color: 'blueGreyLighten',
    summary: 'Distribucion normativa enviada',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "ERJ",
    color: 'blueGreyLighten',
    summary: 'Distribucion rechazado',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "RNO",
    color: 'blueGreyLighten',
    summary: 'Documento no recibido por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "ROK",
    color: 'blueGreyLighten',
    summary: 'Distribucion recibido por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "RAP",
    color: 'blueGreyLighten',
    summary: 'Documento aceptado por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "ROB",
    color: 'blueGreyLighten',
    summary: 'Documento aceptado con discrepancias por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "RRJ",
    color: 'blueGreyLighten',
    summary: 'Documento rechazado por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "ENS",
    color: 'blueGreyLighten',
    summary: 'Email no enviado', // Email not sent
    icon: 'mdi-email-remove-outline'
  },
  {
    id: "EBO",
    color: 'blueGreyLighten',
    summary: 'Email ha rebotado', // Email bounced
    icon: 'mdi-email-arrow-left-outline'
  },
  {
    id: "DCA",
    color: 'blueGreyLighten',
    summary: 'Documento cedido aprobado',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCP",
    color: 'blueGreyLighten',
    summary: 'Documento cedido enviado',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCE",
    color: 'blueGreyLighten',
    summary: 'Documento cedido con error',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCC",
    color: 'blueGreyLighten',
    summary: 'Documento cedido creado',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCN",
    color: 'blueGreyLighten',
    summary: 'Documento cedido anulado',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCR",
    color: 'blueGreyLighten',
    summary: 'Documento cedido rechazado',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "CTP",
    color: 'blueGreyLighten',
    summary: 'Documento cedido',
    icon: 'mdi-file-arrow-left-right-outline'
  }
  /* END AXT */
]